import cx from "classnames";
import Item from "./Item";
import styles from "./Spotlight.module.scss";
import _ from "lodash";

export default function Spotlight({ data }: any) {
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.titleSection)}>{_.get(data, "title")}</div>
      <div className={cx(styles.wrapperItems)}>
        {_.map(_.get(data, "articles"), (item, index) => (
          <Item key={index} data={item} />
        ))}
      </div>
    </div>
  );
}
